<template>
  <v-data-table
    :headers="headers"
    :items="accounts"
    :items-per-page="10"
    class="elevation-1"
  >
    <!-- 名稱欄位 -->
    <template v-slot:item.name="{ item }">
      <span :class="{ 'font-weight-bold': item.is_root }">
        {{ item.name }}
      </span>
    </template>

    <!-- 操作欄位 -->
    <template v-slot:item.actions="{ item }">
      <div class="d-flex gap-2 flex-wrap">
        <!-- 編輯權限（只有一般帳號顯示） -->
        <v-btn
          v-if="!item.is_root"
          text
          small
          color="teal"
          @click="$emit('edit-permissions', item)"
        >
          <v-icon small left>mdi-file-edit-outline</v-icon>
          編輯權限
        </v-btn>

        <!-- 設定帳密（所有帳號都顯示） -->
        <v-btn
          text
          small
          color="teal"
          @click="$emit('edit-credentials', item)"
        >
          <v-icon small left>mdi-lock-outline</v-icon>
          設定帳密
        </v-btn>

        <!-- 以此建立新帳號（所有帳號都顯示） -->
        <v-btn
          text
          small
          color="teal"
          @click="$emit('copy-account', item)"
        >
          <v-icon small left>mdi-content-copy</v-icon>
          以此建立新帳號
        </v-btn>

        <!-- 刪除帳號（只有一般帳號顯示） -->
        <v-btn
          v-if="!item.is_root"
          text
          small
          color="error"
          @click="$emit('delete-account', item)"
        >
          <v-icon small left>mdi-delete-outline</v-icon>
          刪除帳號
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
/**
 * AccountList - 帳號列表表格組件
 *
 * Props:
 * - accounts: 帳號列表資料
 *
 * Events:
 * - edit-permissions: 編輯權限
 * - edit-credentials: 設定帳密
 * - copy-account: 以此建立新帳號
 * - delete-account: 刪除帳號
 */
export default {
  name: 'AccountList',
  props: {
    accounts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      headers: [
        {
          text: '名稱',
          value: 'name',
          sortable: true
        },
        {
          text: '帳號',
          value: 'account',
          sortable: true
        },
        {
          text: '操作',
          value: 'actions',
          sortable: false,
          width: '500px'
        }
      ]
    }
  }
}
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}
</style>
